import React, { forwardRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MaterialTable from "material-table";
import { ToastContainer, toast } from "react-toastify";
import Form from "react-bootstrap/Form";
import {
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Button, Card } from "react-bootstrap";
import axios from "../Components/Axios/Axios";
// Custom Components Import
import Loader from "../Components/Spinner/Spinner";
import Sidebar from "../Components/Sidebar/MainSidebar/Sidebar";
import requests from "../Components/Requests/Requests";
import { InputAdornment } from "@material-ui/core";
import { AccountCircle } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  noBorder: {
    border: "none",
    borderRadius: "5px",
  },
}));

function AllBlogs() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0); // MaterialTable uses 0-based page indexing
  const [totalCount, setTotalCount] = useState(0); // Total count of entries
  const [searchValue, setSearchValue] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  // Function to call API

  // Call API when both values are selected
  useEffect(() => {
    const now = new Date();
    const year1 = now.getFullYear(); // Gets the current year (e.g., 2025)
    const month1 = now.getMonth() + 1; // Gets the current month (0-based, so add 1)

    console.log(`Year: ${year1},${year}, Month: ${month},${month1}`);

    if (year == year1) {
      if (parseInt(month) > month1) {
        // console.log('8888888888888888888')
        toast.error("You cannot select future date");
        setMonth("");
        setYear("");
      }
    }
    if ((month == "" && year == "") || (month != "" && year != "")) {
      console.log("hhiiiiiiiiiiiiiiii");
      fetchData();
    }
  }, [month, year]);

  const tableIcons = {
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  useEffect(() => {
    // Fetch data whenever the page changes
    if (searchValue === "") {
      fetchData(page + 1); // Fetch data for the current page
    } else {
      fetchDataSearch(searchValue, page + 1); // Fetch search data for the current page
    }
  }, [page]); // Triggered when page changes

  const fetchData = async (currentPage) => {
    setLoading(true);
    if (month !== "" && year !== "") {
      try {
        const response = await axios.post(
          requests.coinreport,
          {
            month,
            year,
          },
          { timeout: 30000 },
          {
            headers: {
              Authorization:
                "cb70755a985f963d64ab1bb0541b0980e0edf54931f00c9f7760d17477a90",
            },
          }
        );
        if (response.data.Success === 1) {
          setData(response.data.data); // Set new data
          setTotalCount(response.data.totalCount); // Set total count
        } else {
          toast.warning(`Something went wrong`, {
            position: "top-right",
            autoClose: 2500,
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.warning(err.message, {
          position: "top-right",
          autoClose: 2500,
        });
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const response = await axios.post(
          requests.coinreport,
          {},
          { timeout: 30000 },
          {
            headers: {
              Authorization:
                "cb70755a985f963d64ab1bb0541b0980e0edf54931f00c9f7760d17477a90",
            },
          }
        );
        if (response.data.Success === 1) {
          setData(response.data.data); // Set new data
          setTotalCount(response.data.totalCount); // Set total count
        } else {
          toast.warning(`Something went wrong`, {
            position: "top-right",
            autoClose: 2500,
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.warning(err.message, {
          position: "top-right",
          autoClose: 2500,
        });
      } finally {
        setLoading(false);
      }
    }
  };

  const fetchDataSearch = async (searchValue, currentPage) => {
    setLoading(true);
    try {
      const response = await axios.get(requests.filtercoinreport, {
        params: { page: currentPage, search: searchValue },
        timeout: 30000,
        // Pass 1-based page number and search term to the server
      });
      if (response.data.Success === 1) {
        setData(response.data.data); // Set new data
        setTotalCount(response.data.totalCount); // Set total count
      } else {
        toast.warning(`Something went wrong`, {
          position: "top-right",
          autoClose: 2500,
        });
      }
    } catch (err) {
      toast.warning(err.message, {
        position: "top-right",
        autoClose: 2500,
      });
    } finally {
      setLoading(false);
    }
  };

  // const handlePageChange = (newPage) => {
  //   setPage(newPage); // Update current page
  // };

  const handleSearch = () => {
    // Trigger the search API call when the button is clicked
    setPage(0); // Reset to the first page
    // fetchDataSearch(searchValue, 1); // Fetch search results for the first page
    if (searchValue === "") {
      fetchData(1); // Fetch data for the current page
    } else {
      fetchDataSearch(searchValue, 1); // Fetch search data for the current page
    }
  };

  return (
    <>
      <Sidebar />
      <Container className="content">
        <ToastContainer
          position="top-right"
          autoClose={10000}
          hideProgressBar={false}
        />
        <Card className="card">
          <Card.Header className="heading">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
                alignItems: "ce",
              }}
              className="inside-header"
            >
              Coins Report
              <form class="d-flex align-items-center mt-3 gap-2 ">
                <div class="mr-3">
                  <Form.Select
                    aria-label="Default select example"
                    value={month}
                    onChange={(e) => {
                      setMonth(e.target.value);
                    }}
                  >
                    <option value="">Select Month*</option>
                    <option value="01">January</option>
                    <option value="02">February</option>
                    <option value="03">March</option>
                    <option value="04">April</option>
                    <option value="05">May</option>
                    <option value="06">June</option>
                    <option value="07">July</option>
                    <option value="08">August</option>
                    <option value="09">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </Form.Select>
                </div>
                <div class="mr-3">
                  <Form.Select
                    aria-label="Default select example"
                    value={year}
                    onChange={(e) => {
                      setYear(e.target.value);
                    }}
                  >
                    <option value="">Select Year*</option>
                    <option value="2025">2025</option>
                    <option value="2024">2024</option>
                  </Form.Select>
                </div>
              </form>
              {/* <div className="searchbarUser">
                <TextField
                  variant="outlined"
                  placeholder="Search..."
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                 

      autoFocus
      classes={{notchedOutline:classes.input}}

    
      className={classes.textField}
    
      InputProps={{
        
        classes:{notchedOutline:classes.noBorder}
      }}
                  style={{
                    marginRight: "0px",
                    padding: "0px",
                    
                    border: "1px solid #d2d2d2",
                  }}
                />
                <Button onClick={handleSearch} variant="primary">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19"><g id="Group_40" data-name="Group 40" transform="translate(-0.001)"><g id="layer1_00000072963618680574873660000015406673454742146451_" transform="translate(0.001)"><g id="g18115"><path id="path17034" d="M9.743,292.644A7.748,7.748,0,1,0,14.5,306.5l4.869,4.869a.95.95,0,0,0,1.343-1.343l-4.869-4.869a7.739,7.739,0,0,0-6.1-12.51Zm0,1.9a5.849,5.849,0,1,1-5.849,5.849A5.835,5.835,0,0,1,9.743,294.544Z" transform="translate(-1.995 -292.644)" fill="#B95BD0"></path></g></g></g></svg>
                </Button>
              </div> */}
            </div>
          </Card.Header>
          <Card.Body className="body">
            {loading ? (
              <Loader margin={"auto"} />
            ) : (
              <MaterialTable
                data={data} // Data to be displayed in the table
                icons={tableIcons}
                columns={[
                  {
                    title: "S.No.",
                    field: "tableData.id",
                    render: (rowData) => rowData.tableData.id + 1,
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                      borderLeft: "1px solid #e0e0e0",
                      wordBreak: "break-all",
                    },
                    customFilterAndSearch: (term, rowData) =>
                      (rowData.tableData.id + 1).toString().includes(term),
                  },
                  {
                    title: "Purchased coins",
                    field: "purchased_coin",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                      wordBreak: "break-all",
                    },
                  },
                  {
                    title: "Premium coins used",
                    field: "premium_coins_used",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                      wordBreak: "break-all",
                    },
                  },
                  {
                    title: "Simple coins used",
                    field: "simple_coins_used",
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                      wordBreak: "break-all",
                    },
                  },
                  {
                    title: "Date",
                    field: "date",
                    render: (rowData) => rowData.date.split("T")[0],
                    cellStyle: {
                      borderRight: "1px solid #e0e0e0",
                      wordBreak: "break-all",
                    },
                  },

                  {
                    title: "Actions",
                    sorting: false,
                    render: (rowData) => (
                      <Link
                        to={{
                          pathname: "/single-day-coin-earn",
                          state: rowData,
                        }}
                      >
                        <Button variant="primary" size="md">
                          View
                        </Button>
                      </Link>
                    ),
                  },
                ]}
                options={{
                  pageSize: 30,
                  paginationType: "normal",
                  showTitle: false,
                  pagination: true,
                  pageSizeOptions: false, // Disable page size selector
                  tableLayout: "auto",
                  // search:false,
                  rowStyle: (rowData, index) => ({
                    backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff", // Alternate colors
                  }),
                }}
                totalCount={totalCount} // Total number of rows (from backend)
                page={page} // Current page number (state)
                // onChangePage={(newPage) => handlePageChange(newPage)} // Handle page change event
                localization={{
                  pagination: {
                    labelRowsSelect: "rows",
                    labelDisplayedRows: "{from}-{to} of {count}",
                  },
                }}
              />
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}

export default AllBlogs;
